export default __webpack_public_path__ + "static/media/Logo.a9f4dab6.png";